// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/7d7cf3b3/" + chunkId + "." + __webpack_require__.h() + ".v7d7cf3b3.js";
};